import React, { memo } from "react";

import { formatCustomSpecsFromApi } from "./Helper";

import { ReactComponent as InformationIcon } from "../../../../../assets/images/product/specmanager/information-line.svg";
import { ReactComponent as ShieldCheckIcon } from "../../../../../assets/images/product/specmanager/shield-check-line.svg";

import "./ProductSpecTypeBadge.css";

const APPEARANCE_CLASSES = {
  productList: {
    root: "ProductList__SelectedItemBadge",
    icon: "ProductList__SelectedItemBadgeIcon",
    custom: "ProductList__SelectedItemBadge--custom",
    standard: "ProductList__SelectedItemBadge--standard",
  },
  testSpecOverview: {
    root: "TestSpecOverview__ProductBadge",
    icon: "TestSpecOverview__BadgeIcon",
    custom: "TestSpecOverview__ProductBadge--custom",
    standard: "TestSpecOverview__ProductBadge--standard",
  },
};

/**
 * Standard vs custom spec pill for a product row (selected list or overview).
 * @param {Object} props
 * @param {"standard"|"custom"} props.variant
 * @param {{ min?: string, max?: string, unit?: string }} [props.customSpecs] API `custom_specs` when variant is custom
 * @param {"productList"|"testSpecOverview"} [props.appearance]
 * @param {boolean} [props.suppressNativeTitle] Omit browser `title` (e.g. when wrapped in StyledTooltip)
 */
function ProductSpecTypeBadge({
  variant,
  customSpecs,
  appearance = "productList",
  suppressNativeTitle = false,
}) {
  const classes = APPEARANCE_CLASSES[appearance] || APPEARANCE_CLASSES.productList;
  const isCustom = variant === "custom";
  const modifier = isCustom ? classes.custom : classes.standard;
  const specSummary = isCustom ? formatCustomSpecsFromApi(customSpecs) : "";
  let nativeTitle;
  if (!suppressNativeTitle && isCustom && specSummary) {
    nativeTitle = `Custom: ${specSummary}`;
  }

  let labelCluster;
  if (!isCustom) {
    labelCluster = <span>Standard</span>;
  } else if (specSummary) {
    labelCluster = (
      <>
        <span className="ProductSpecTypeBadge__customPrefix">Custom:&nbsp;</span>
        {" "}
        <span className="ProductSpecTypeBadge__specPart">{specSummary}</span>
      </>
    );
  } else {
    labelCluster = <span>Custom</span>;
  }

  return (
    <div className={`${classes.root} ${modifier}`} title={nativeTitle}>
      {isCustom ? (
        <InformationIcon className={classes.icon} />
      ) : (
        <ShieldCheckIcon className={classes.icon} />
      )}
      <span className="ProductSpecTypeBadge__textCluster">
        {labelCluster}
      </span>
    </div>
  );
}

export default memo(ProductSpecTypeBadge);
